import { ExamCard, AttachmentCard } from '../../components';
import { Attachment, Exam } from '../../../../../../types/Assemblage';
import { utils as u, Heading, Container } from 'edrolo-ui';
import cx from 'classnames';

interface Props {
  id: string;
  title: string;
  attachments: Attachment[];
  exams: Exam[];
  classId: ClassId;
  courseId: number;
  topicId?: number;
  insightsAvailabilityFlagName: string;
}

export const AdditionalMaterials = ({
  id,
  title,
  attachments,
  exams,
  classId,
  courseId,
  topicId,
  insightsAvailabilityFlagName,
}: Props) => (
  <section id={id}>
    <Container>
      <Heading.Display className={u.mb6} level={2}>
        {title}
      </Heading.Display>

      <div className={cx(u.grid, u.gap4)}>
        {exams.map((exam: Exam) => {
          if (!exam.is_submittable) {
            return null;
          } else {
            return (
              <ExamCard
                key={exam.id}
                exam={exam}
                topicId={topicId}
                insightsAvailabilityFlagName={insightsAvailabilityFlagName}
              />
            );
          }
        })}

        {attachments.map((attachment: Attachment) => (
          <AttachmentCard
            key={attachment.id}
            classId={classId}
            courseId={courseId}
            attachment={attachment}
          />
        ))}
      </div>
    </Container>
  </section>
);
